/*eslint-disable*/
import React from 'react';
import DataGrid, { MasterDetail, Column, Paging } from 'devextreme-react/data-grid';
import { config } from '../../../utils/config';
import { callApi, callKrakenApi } from '../../../utils/utils';

export default class LoteMinimoGridDet extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pageIndex: 0,
      dataDetalle: [],
    };
    this.handleOptionChange = this.handleOptionChange.bind(this);
    this.getLoteMinimoData = this.getLoteMinimoData.bind(this);
    this.onGridPage = this.onGridPage.bind(this);
  }

  getLoteMinimoData() {
    const filtros = {
      claUbicacion: null,
      claFamilia: null,
      claSubFamilia: null,
      claProducto: null,
      claPedido: null,
      idLote: this.props.idLote,
      estatusLote: 0,
      tipoLote: 0,
    };

    const urlApiService = `${process.env.REACT_APP_URL_API}LoteMinimo/LoteMinimoBusqueda`;

    callApi(urlApiService, 'POST', filtros, (result) => {
      console.log(result);
      this.setState({
        dataDetalle: result[1],
      });
    });
  }

  onGridPage(pageIndex) {
    this.setState({ pageIndex });
  }

  handleOptionChange(e) {
    if (e.fullName === 'paging.pageIndex') {
      this.onGridPage(e.value);
    }
  }

  componentDidMount() {
    this.getLoteMinimoData();
  }

  render() {
    const gridContent = (
      <div>
        <DataGrid
          dataSource={this.state.dataDetalle}
          height={600}
          width="100%"
          selection={{ mode: 'single' }}
          showBorders={false}
          columnHidingEnabled
          columnAutoWidth={false}
          showColumnHeaders
          showColumnLines={false}
          showRowLines
          noDataText="Sin Registros"
          wordWrapEnabled
          rowAlternationEnabled={false}
          onOptionChanged={this.handleOptionChange}
        >
          <Column dataField="IdLote" caption="Lote" width={100} />
          <Column dataField="ClaPedido" caption="Pedido" width={100} />
          <Column dataField="ClaUbicacion" caption="Ubicación" width={100} visible={false} />
          <Column
            dataField="ClaUbicacionElabora"
            caption="Ubicación Elabora"
            width={100}
            visible={false}
          />
          <Column dataField="NomUbicacionElabora" caption="Ubicación Elabora" width={120} />
          <Column dataField="NomUbicacion" caption="Ubicación" width={120} />
          <Column dataField="IdRenglon" caption="Renglón" width={100} />
          <Column dataField="ClaArticulo" caption="Artículo" width={100} visible={false} />
          <Column dataField="NomArticulo" caption="Artículo" width={120} />
          <Column dataField="CantidadDeuda" caption="Deuda" width={100} />

          <Paging pageSize={30} pageIndex={this.props.pageIndex} />
        </DataGrid>
      </div>
    );

    return <>{gridContent}</>;
  }
}
